import { combineReducers } from "redux";
import {
    infoData,
    skillSetData
} from "./Reducer";

export default combineReducers({
    infoData,
    skillSetData
});
